import api from './api';

export const tenantService = {
  getAllTenants: async (params) => {
    const response = await api.get('/admin/tenants', { params });
    return response.data;
  },

  getTenant: async (id) => {
    const response = await api.get(`/admin/tenants/${id}`);
    return response.data;
  },

  createTenant: async (data) => {
    const response = await api.post('/admin/tenants', data);
    return response.data;
  },

  updateTenant: async (id, data) => {
    const response = await api.put(`/admin/tenants/${id}`, data);
    return response.data;
  },

  deleteTenant: async (id) => {
    const response = await api.delete(`/admin/tenants/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },
};

export const subscriptionService = {
  getAllPlans: async () => {
    const response = await api.get('/subscription-plans');
    return response.data;
  },

  createPlan: async (data) => {
    const response = await api.post('/admin/subscription-plans', data);
    return response.data;
  },

  updatePlan: async (id, data) => {
    const response = await api.put(`/admin/subscription-plans/${id}`, data);
    return response.data;
  },

  deletePlan: async (id) => {
    const response = await api.delete(`/admin/subscription-plans/${id}`);
    return response.data;
  },
};
